import { render, staticRenderFns } from "./partInquriyDetail.vue?vue&type=template&id=2ab34938&scoped=true&"
import script from "./partInquriyDetail.vue?vue&type=script&lang=js&"
export * from "./partInquriyDetail.vue?vue&type=script&lang=js&"
import style0 from "./partInquriyDetail.vue?vue&type=style&index=0&id=2ab34938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab34938",
  null
  
)

export default component.exports